import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FolderHasActiveUploadLinksFragment = { __typename?: 'FolderAsset', id: string, hasActiveUploadLinks?: boolean | null };

export const FolderHasActiveUploadLinks = /*#__PURE__*/ gql`
    fragment FolderHasActiveUploadLinks on FolderAsset {
  id
  hasActiveUploadLinks
}
    ` as unknown as DocumentNode<FolderHasActiveUploadLinksFragment, unknown>;

        

        
export const useFolderHasActiveUploadLinksFragment = (
  input: string | Omit<UseFragmentOptions<FolderHasActiveUploadLinksFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'FolderAsset' } };
    return input;
  })();

  return useFragment<FolderHasActiveUploadLinksFragment>({
    fragment: FolderHasActiveUploadLinks,
    fragmentName: 'FolderHasActiveUploadLinks',
    ...options,
  });
};
  
        